import {type NumericLine} from '../vis/chartSeries';

/**
 * Splits display lines for the chart and legend.
 * - Legend lines leave out aux lines (bands and areas), which are drawn but
 *   are not runs.
 * - Visible lines have data or NaN points; hidden lines have neither and are
 *   listed separately in the legend.
 */
export function partitionLines(lines: NumericLine[]): {
  hiddenLines: NumericLine[];
  legendLines: NumericLine[];
  visibleLines: NumericLine[];
} {
  const legendLines = lines.filter(line => line.role === 'primary');
  const visibleLines: NumericLine[] = [];
  const hiddenLines: NumericLine[] = [];
  for (const line of lines) {
    const hasData =
      line.data.length > 0 ||
      (line.nanPoints != null && line.nanPoints.length > 0);
    if (hasData) {
      visibleLines.push(line);
    } else {
      hiddenLines.push(line);
    }
  }
  return {hiddenLines, legendLines, visibleLines};
}
